import React from "react";
import "./Sidebar.css";

const Sidebar = ({ onSelect }) => {
  return (
    <div className="sidebar">
      <div className="sidebar-title">Academics</div>
      <ul className="sidebar-nav">
        <li onClick={() => onSelect("Primary")}>Primary</li>
        <li onClick={() => onSelect("Sec (Key Stage 3)")}>Sec (Key Stage 3)</li>
        <li onClick={() => onSelect("Sec (Key Stage 4)")}>Sec (Key Stage 4)</li>
        <li onClick={() => onSelect("Sec (Key Stage 5)")}>Sec (Key Stage 5)</li>
      </ul>
    </div>
  );
};

export default Sidebar;
